import { colors } from "@dotnet/telematics-design-system";

import { body3Regular } from "shared/styles/typography";

import { InfoComponentProps } from "./types";

const InfoComponent = ({
    title,
    isDisabled,
    customStyle
}: InfoComponentProps) => {
    const { gray700, textDisabled } = colors;

    return (
        <span
            css={[
                body3Regular,
                {
                    color: isDisabled ? textDisabled : gray700,
                    marginBottom: "2px",
                    ...customStyle
                }
            ]}
        >
            {title}
        </span>
    );
};

export { InfoComponent };
